import Swiper, { Pagination, A11y } from 'swiper'
Swiper.use([Pagination, A11y])

import { select } from '@js/util/select.js'
import { renderBullet } from './a11y.js'
import swiperHandleKeyboardFocus from '@js/util/swiper-handle-keyboard-focus'

select('.wpce-slider-integrated', sliderElement => {
  let swiper = new Swiper(`#${sliderElement.dataset.swiperId}`, {
    threshold: 30,
    spaceBetween: 60,
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      bulletElement: 'button',
      clickable: 'true',
      renderBullet(index, className) {
        return renderBullet(this, index, className)
      },
    },
    a11y: {
      enabled: true,
      containerRoleDescriptionMessage: 'carousel',
      itemRoleDescriptionMessage: 'slide',
      paginationBulletMessage: null,
    },
  })

  // Keyboard focus is not handled by Swiper.js itself
  swiperHandleKeyboardFocus(swiper)

  // Had to include manually because of a bug in chrome
  const nextButton = sliderElement.querySelector('.slider-button-next')

  function handleNextButtonDisabled() {
    if (!nextButton) return
    nextButton.disabled = swiper.isEnd
  }

  handleNextButtonDisabled()
  swiper.on('slideChange', handleNextButtonDisabled)
  swiper.on('afterInit', handleNextButtonDisabled)

  function onNextClick() {
    swiper.slideNext()
  }
  nextButton?.addEventListener('click', onNextClick)

  const prevButton = sliderElement.querySelector('.slider-button-prev')

  function handlePrevButtonDisabled() {
    if (!prevButton) return
    prevButton.disabled = swiper.isBeginning
  }

  handlePrevButtonDisabled()
  swiper.on('slideChange', handlePrevButtonDisabled)
  swiper.on('afterInit', handlePrevButtonDisabled)

  function onPrevClick() {
    swiper.slidePrev()
  }
  prevButton?.addEventListener('click', onPrevClick)

  // Handle swiper destroy
  swiper.once('beforeDestroy', () => {
    prevButton?.removeEventListener('click', onPrevClick)
    nextButton?.removeEventListener('click', onNextClick)
  })

  return () => {
    swiper.destroy()
  }
})
